import { lastBodyCellStyle, bodyCellStyle } from './styles';

export const isLastItemOnList = (lst: any[], idx: number) => lst.length - 1 === idx;

export const getStyle = (lst: any[], idx: number) =>
    isLastItemOnList(lst, idx) ? lastBodyCellStyle : bodyCellStyle;
